import { createSelector } from 'reselect';
import { getActiveLocaleSelector } from '@americanexpress/travel-selectors';
import { buildMarketConfig } from '../utils/marketConfigUtils';

export const getMarketConfig = createSelector(
  getActiveLocaleSelector,
  (locale) => buildMarketConfig(locale)
);
